module.exports = __webpack_public_path__ + "static/img/pc-img7.57ebb6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/519celebrate/pc-img7.jpg
// module id = NHWG
// module chunks = 0